/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTranslation } from 'react-i18next';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import { useDispatch } from 'react-redux';
import { get } from 'lodash';
import { useMediaQuery } from '@mui/material';
import { useLocalStorage } from '../../../../constants/CustomHooks/useLocalStorage';
import './dropdown-menu.scss';
import * as actions from '../../../../store/actions';

const DropdownMenu = (props) => {
    const [preferedLanguage, setPreferedLanguage] = useLocalStorage(
        'preferedLanguage',
        '',
    );
    const { i18n } = useTranslation();
    const mobile = useMediaQuery('(max-width:575px)');
    const [activeLang, setActiveLang] = useState(
        preferedLanguage === 'es' ? 'Español' : 'English',
    );
    const type = get(props, 'type', 'home');
    const [anchorEl, setAnchorEl] = useState(null);
    const dispatch = useDispatch();

    // Use useEffect to handle dispatch with an appropriate dependency
    useEffect(() => {
        dispatch(actions.menuOpen(Boolean(anchorEl)));
    }, [dispatch, anchorEl]);

    const open = Boolean(anchorEl);
    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = (lang) => {
        setAnchorEl(null);
        setActiveLang(lang);
        setPreferedLanguage(lang === 'English' ? 'en' : 'es');
        i18n.changeLanguage(lang === 'English' ? 'en' : 'es');
    };
    const verticalAlignMob = mobile ? -119 : -97;

    useEffect(() => {
        window.addEventListener('scroll', () => setAnchorEl(null));
        return () =>
            window.removeEventListener('scroll', () => setAnchorEl(null));
    }, []);

    return (
        <>
            <Button
                className="language-button"
                aria-controls={open ? 'customized-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="outlined"
                sx={{
                    color: 'pureWhite.main',
                    svg: {
                        color: 'primary.main',
                    },
                    backgroundColor: '#000 !important',
                    borderColor: 'primary.main',
                }}
                disableElevation
                onClick={handleClick}
                startIcon={<LanguageRoundedIcon />}
                endIcon={<ArrowDropDownIcon />}
            >
                {activeLang}
            </Button>

            <Menu
                MenuListProps={{
                    className: `dropdown-menu-container ${
                        type === 'signin' && 'dropdown-menu-container-signin'
                    } `,
                    // 'aria-labelledby': 'customized-button',
                }}
                anchorOrigin={{
                    vertical: type === 'signin' ? verticalAlignMob : 35,
                    horizontal: 0,
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose(activeLang)}
            >
                <MenuItem
                    className="language-menuitem"
                    onClick={() => handleClose('English')}
                    disableRipple
                >
                    English
                </MenuItem>
                <MenuItem
                    className="language-menuitem"
                    onClick={() => handleClose('Español')}
                    disableRipple
                >
                    Español
                </MenuItem>
            </Menu>
        </>
    );
};

export default DropdownMenu;
